import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthGate } from '@/auth/AuthGate';
import { MissionControl } from '@/modules/mission-control/MissionControlPage';
import { LoginPage } from '@/modules/login/LoginPage';
import { ChessDemoPage } from '@/modules/chess-demo/ChessDemoPage';
import { RepertoireListPage } from '@/modules/opening-lab/RepertoireListPage';
import { RepertoireDrillPage } from '@/modules/opening-lab/RepertoireDrillPage';
import { GameListPage } from '@/modules/game-autopsy/GameListPage';
import { AutopsyPage } from '@/modules/game-autopsy/AutopsyPage';
import { TacticsListPage } from '@/modules/tactics-dojo/TacticsListPage';
import { TacticsDrillPage } from '@/modules/tactics-dojo/TacticsDrillPage';
import { EndgameListPage } from '@/modules/endgame-forge/EndgameListPage';
import { EndgameDrillPage } from '@/modules/endgame-forge/EndgameDrillPage';
import { ParentLoginPage } from '@/modules/parent/ParentLoginPage';
import { ParentDashboardPage } from '@/modules/parent/ParentDashboardPage';
import { StatsPage } from '@/modules/stats/StatsPage';
import { PracticeArenaListPage } from '@/modules/practice-arena/PracticeArenaListPage';
import { PracticeSetupPage } from '@/modules/practice-arena/PracticeSetupPage';
import { PracticeGamePage } from '@/modules/practice-arena/PracticeGamePage';
import { PracticeReviewPage } from '@/modules/practice-arena/PracticeReviewPage';
import { BadgesPage } from '@/modules/practice-arena/BadgesPage';
import { RevisionCardsPage } from '@/modules/revision-cards/RevisionCardsPage';
import { RevisionDrillPage } from '@/modules/revision-cards/RevisionDrillPage';

export function App() {
  return (
    <div className="min-h-screen bg-ink-900 text-paper-50">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/parent" element={<ParentLoginPage />} />
        <Route path="/parent/dashboard" element={<ParentDashboardPage />} />
        <Route
          path="/"
          element={
            <AuthGate>
              <MissionControl />
            </AuthGate>
          }
        />
        <Route
          path="/opening-lab"
          element={
            <AuthGate>
              <RepertoireListPage />
            </AuthGate>
          }
        />
        <Route
          path="/opening-lab/:slug"
          element={
            <AuthGate>
              <RepertoireDrillPage />
            </AuthGate>
          }
        />
        <Route
          path="/game-autopsy"
          element={
            <AuthGate>
              <GameListPage />
            </AuthGate>
          }
        />
        <Route
          path="/game-autopsy/:gameId"
          element={
            <AuthGate>
              <AutopsyPage />
            </AuthGate>
          }
        />
        <Route
          path="/tactics-dojo"
          element={
            <AuthGate>
              <TacticsListPage />
            </AuthGate>
          }
        />
        <Route
          path="/tactics-dojo/drill"
          element={
            <AuthGate>
              <TacticsDrillPage />
            </AuthGate>
          }
        />
        <Route
          path="/endgame-forge"
          element={
            <AuthGate>
              <EndgameListPage />
            </AuthGate>
          }
        />
        <Route
          path="/endgame-forge/:slug"
          element={
            <AuthGate>
              <EndgameDrillPage />
            </AuthGate>
          }
        />
        <Route
          path="/chess-demo"
          element={
            <AuthGate>
              <ChessDemoPage />
            </AuthGate>
          }
        />
        <Route
          path="/stats"
          element={
            <AuthGate>
              <StatsPage />
            </AuthGate>
          }
        />
        <Route
          path="/practice-arena"
          element={
            <AuthGate>
              <PracticeArenaListPage />
            </AuthGate>
          }
        />
        <Route
          path="/practice-arena/setup"
          element={
            <AuthGate>
              <PracticeSetupPage />
            </AuthGate>
          }
        />
        <Route
          path="/practice-arena/game/:id"
          element={
            <AuthGate>
              <PracticeGamePage />
            </AuthGate>
          }
        />
        <Route
          path="/practice-arena/review/:id"
          element={
            <AuthGate>
              <PracticeReviewPage />
            </AuthGate>
          }
        />
        <Route
          path="/practice-arena/badges"
          element={
            <AuthGate>
              <BadgesPage />
            </AuthGate>
          }
        />
        <Route
          path="/revision-cards"
          element={
            <AuthGate>
              <RevisionCardsPage />
            </AuthGate>
          }
        />
        <Route
          path="/revision-cards/drill/:cardId"
          element={
            <AuthGate>
              <RevisionDrillPage />
            </AuthGate>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}
